/**
 * @author Madhu.Sudhan
 * @Date: 2023-04-25 13:13:07
 * @Last Modified by: madhusudhan
 * @Last Modified time: 2023-04-25 15:44:52
 */

import { fromJS } from 'immutable';
import { DEFAULT_ACTION, FETCH_YSC_TRANSACTION_LIMIT, GENERATE_OTP, UPDATE_YSC_TRANSACTION_LIMIT } from './constants';

const initialState = fromJS({
  isLoading: false,
  fetchYscTransactionLimits: {},
  updateYscTransactionLimits: {},
  generateOtp: {},
});

function yscTransactionLimitsReducer(state = initialState, action) {
  const { payload, type } = action;
  switch (type) {
    case DEFAULT_ACTION:
      return state
        .set('isLoading', payload);
    case FETCH_YSC_TRANSACTION_LIMIT:
      return state
        .set('fetchYscTransactionLimits', fromJS(payload))
        .set('isLoading', false);
    case UPDATE_YSC_TRANSACTION_LIMIT:
      return state
        .set('updateYscTransactionLimits', fromJS(payload))
        .set('isLoading', false);
    case GENERATE_OTP:
      return state
        .set('generateOtp', fromJS(payload))
        .set('isLoading', false);
    default:
      return state;
  }
}

export default yscTransactionLimitsReducer;



// WEBPACK FOOTER //
// client/containers/YscTransactionLimits/reducer.js